<template>
  <div class="row poppins h-100">
    <div class="col-12 h-100 d-flex flex-column">
      <div class="d-flex justify-content-between mb-3 pb-1">
        <div class="filters-block">
          <div class="mr-2">
            <SearchInput :search-change="searchChange" />
          </div>
        </div>
        <div v-if="showDateFilter" class="d-flex align-items-end">
          <DateRange :update="dateRange" />
        </div>
        <div class="action-buttons-wrapper" v-if="showActions">
          <b-button @click="addButton" variant="primary" size="lg" class="ml-3" v-if="!hideAdd">
            <BIconPlus />{{ `Add ${instanceName}` | i18n }}
          </b-button>
          <Details :id="`${instance}-details`" :title="`${instanceName} details`" :details="details" :init-data="selectedInstance" />
          <UpsertInstance
            :id="`add-${instance}-modal`"
            :get-page="getPage"
            :title="`New ${instanceName}`"
            :on-save="(d) => create(d)"
            :upsert="upsert"
          />
          <UpsertInstance
            :id="`edit-${instance}-modal`"
            :get-page="getPage"
            :title="`Edit ${instanceName}`"
            :init-data="selectedInstance"
            :on-save="(d) => update(d)"
            type="edit"
            :upsert="upsert"
          />
          <b-button variant="outline-danger" size="lg" class="ml-3" :disabled="!selectedList.length" @click="deleteInstance" v-if="!hideDelete">
            {{ `Remove ${instanceName}` | i18n }}
          </b-button>
        </div>
      </div>
      <div class="table-wrapper overflow-hidden d-flex flex-column">
        <div v-if="shiftLogToogle" style="margin-bottom: 10px">
          <div class="toogle-wrapper">
            {{ 'Current Logs' | i18n }}
            <div
              class="toogle-body"
              :style="`justify-content:${shiftLogToogleValue ? 'flex-start' : 'flex-end'}`"
              @click="toogleShiftLogFilter"
            >
              <div class="toogle-cycle"></div>
            </div>
            {{ 'Future Logs (Planning)' | i18n }}
          </div>
        </div>
        <Table
          :update="getPage"
          :columns="c"
          :rows="rows"
          :filter="filter"
          :update-filter="updateFilter"
          :loading-instance="loadingInstance"
          :set-loading-instance="setLoadingInstance"
          :selected-list="selectedList"
          :set-selected-list="setSelectedList"
          class="overflow-auto pr-1"
          table-name="instanceTable"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { BIconPlus } from 'bootstrap-vue';

import { DeleteRowMixin, NotificationMixin } from '../../../mixins';
import Table from '../common/table';
import SearchInput from '../common/search-input';
import DateRange from '../common/date-range';

import UpsertInstance from './upsert-instance';
import Details from './details';

let inputInterval = null;

export default {
  title: 'Instance',
  components: { BIconPlus, Table, UpsertInstance, SearchInput, DateRange, Details },
  mixins: [DeleteRowMixin, NotificationMixin],
  props: {
    instance: {
      type: String,
      default: '',
    },
    upsert: {
      type: Array,
      default: () => [],
    },
    details: {
      type: Array,
      default: () => [],
    },
    instanceName: {
      type: String,
      default: '',
    },
    create: {
      type: Function,
      default: () => {},
    },
    initFilter: {
      type: Object,
      default: () => {},
    },
    update: {
      type: Function,
      default: () => {},
    },
    get: {
      type: Function,
      default: () => {},
    },
    delete: {
      type: Function,
      default: () => {},
    },
    columns: {
      type: Function,
      default: () => [],
    },
    header: {
      type: Boolean,
      default: true,
    },
    headerBg: {
      type: String,
      default: '',
    },
    showActions: {
      type: Boolean,
      default: true,
    },
    showDateFilter: {
      type: Boolean,
      default: false,
    },
    onAddAction: {
      type: Function,
      default: null,
    },
    hideDelete: {
      type: Boolean,
      default: false,
    },
    hideAdd: {
      type: Boolean,
      default: false,
    },
    shiftLogToogle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      c: [],
      selectedList: [],
      selectedInstance: {},
      loadingInstance: null,
      filter: {
        page: 1,
        limit: 20,
        totalCount: 0,
        sortBy: '',
        sortOrder: '',
        searchQuery: '',
        startDate: '',
        endDate: '',
      },
      rows: [],
      shiftLogToogleValue: true,
    };
  },
  created: function () {
    if (this.initFilter) {
      this.filter = this.initFilter;
    }
    this.c = this.columns({ editInstance: this.editInstance, instanceDetails: this.instanceDetails });
  },
  methods: {
    toogleShiftLogFilter() {
      this.shiftLogToogleValue = !this.shiftLogToogleValue;
      if (this.shiftLogToogleValue) {
        this.filter.endDate = moment().format('YYYY-MM-DD');
      } else {
        this.filter.endDate = '';
      }
      this.getPage();
    },
    dateRange(d) {
      this.filter.startDate = d.startDate;
      this.filter.endDate = d.endDate;
      this.getPage();
    },
    addButton() {
      if (this.onAddAction) {
        return this.onAddAction();
      }
      this.$root.$emit('bv::show::modal', `add-${this.instance}-modal`);
    },
    editInstance(user) {
      this.selectedInstance = user;
      setTimeout(() => {
        this.$root.$emit('bv::show::modal', `edit-${this.instance}-modal`);
      }, 100);
    },
    instanceDetails(data) {
      this.$router.push({ name: 'details', params: { header: this.instanceName, data, details: this.details } });
      // console.log('instanceDetails');
      // this.selectedInstance = user;
      // setTimeout(() => {
      //   this.$root.$emit('bv::show::modal', `${this.instance}-details`);
      // }, 100);
    },
    updateFilter(f) {
      this.filter = {
        ...this.filter,
        ...f,
      };
    },
    setSelectedList(list) {
      this.selectedList = list;
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    searchChange(e) {
      const v = e.target.value;
      this.filter.searchQuery = v;
      if (inputInterval) {
        clearTimeout(inputInterval);
      }
      inputInterval = setTimeout(() => {
        this.getPage();
      }, 500);
    },
    async deleteInstance() {
      try {
        await this.deleteSelectedRows({}, async () => {
          const ids = this.selectedList.map((r) => r.id);
          await this.delete({ ids });
          this.rows = this.rows.filter((i) => !ids.includes(i.id));
          this.selectedList = [];
          this.getPage();
        });
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    startLoading() {
      this.loadingInstance.show();
    },
    stopLoading() {
      this.loadingInstance.close();
    },
    async getPage() {
      try {
        this.startLoading();
        const { page, limit, sortBy, sortOrder, searchQuery, startDate, endDate } = this.filter;
        const ctx = {
          page,
          limit,
          sortBy,
          sortOrder,
          searchQuery,
        };
        if (startDate) {
          ctx.startDate = startDate;
        }
        if (endDate) {
          ctx.endDate = endDate;
        }
        const response = await this.get(ctx);
        this.filter.totalCount = response.totalCount;
        this.stopLoading();

        this.rows = response.data;
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.filters-block {
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

::v-deep .ve-table-body {
  ::v-deep th {
    color: rgb(112, 112, 112) !important;
    background-color: rgb(239, 239, 239) !important;
    border: none !important;
    min-height: 50px;
  }
  ::v-deep td {
    color: rgb(112, 112, 112) !important;
    cursor: pointer;
  }
}

::v-deep .ve-table-cell-selection {
  border: none !important;
}

::v-deep .ve-table-sort {
  top: -4.5px;
}

::v-deep .details-action {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: rgb(34, 129, 254);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 20px;
  margin: 0 10px;
  cursor: pointer;
}

.statuses-block {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.date-range-block {
  min-width: 350px;
  text-align: center;
  margin-left: 30px;
  display: flex;
  align-items: center;
}

::v-deep .ve-select-selected-span {
  font-weight: 400;
}

.pagination-block {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

::v-deep .copy-button {
  background: rgb(237, 248, 254);
  border: 2px solid rgb(175, 216, 255);
  border-radius: 4px;
  padding: 2px 13px;
  margin: 0px 5px;
  color: rgb(49, 141, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-right: 20px;
}

::v-deep .action-block {
  display: flex;
  justify-content: center;
}

::v-deep .action-buttons {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.action-buttons-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.action-buttons-wrapper button {
  white-space: nowrap;
}

.toogle-wrapper {
  display: flex;
  align-items: center;
  margin-right: 45px;
}

.icon-toogle {
  width: 18px;
  height: 18px;
  margin: 0 5px;
  cursor: pointer;
}

.toogle-body {
  min-width: 40px;
  width: 40px;
  height: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 0 3px;
  cursor: pointer;
  border: 1px solid #80bdff;
  margin: 0 15px;
}

.toogle-cycle {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #2260ff;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
